import { connect } from 'react-redux'

import { getInsertCardOrders, getIsAdmin } from 'registry/reducers'
import InsertCardsSection from '../components/insert-cards-section'

const mapStateToProps = (state, ownProps) => {
  return {
    insertCardOrders: getInsertCardOrders(state),
    isAdmin: getIsAdmin(state),
  }
}

export default connect(mapStateToProps)(InsertCardsSection)
